<template>
	<div class="slot-ban">
		<router-link :to="banner.link" v-if="banner && !banner.blank">
			<div class="itemHolder" :style="'background-image: url('+encodeURI(banner.image)+')'">
				<div class="blockHolder" v-if="banner.title !== 'noname'">
					<h2 v-html="banner.title"></h2>
					<div class="textHolder" v-html="banner.content" v-if="banner.content">

					</div>
				</div>
			</div>
		</router-link>
		<a target="_blank" :href="banner.link" v-else-if="banner && banner.blank">
			<div class="itemHolder" :style="'background-image: url('+encodeURI(banner.image)+')'">
				<div class="blockHolder" v-if="banner.title !== 'noname'">
					<h2 v-html="banner.title"></h2>
					<div class="textHolder" v-html="banner.content" v-if="banner.content">

					</div>
				</div>
			</div>
		</a>
	</div>

</template>

<script>

	export default {
		name: "banner",
		props: ['priority'],
		computed:{
			banner(){
				if(this.$store.state.once.banners !== null){
					return this.$store.state.once.banners.find((el)=> el.priority === this.priority);
				}

				return null;
			}
		},
		mounted(){
			this.$store.dispatch('getBanners');
		}
	}
</script>

<style scoped>

</style>